export default __webpack_public_path__ + "static/media/60fd718ae1253630a08d899141592946.ce2f01e5.jpeg";